import type React from 'react';

import { Grid, Typography } from '@mui/material';

import LinkButton, { type LinkButtonProps } from 'components/buttons/LinkButton';
import { useStyles } from 'components/panels/eventsSplitDraws/selectedEvent/styles';
import { BodyRegularBold } from 'components/typography/Typography';

interface RankingLinkButtonProps extends LinkButtonProps {
  label?: string;
  disableAction?: boolean;
  adornment?: React.ReactNode;
}

const RankingLinkButton: React.FC<React.PropsWithChildren<RankingLinkButtonProps>> = ({
  label,
  children,
  disableAction,
  adornment = '',
  ...props
}) => {
  const { classes } = useStyles();

  if (disableAction) {
    return (
      <Grid item className={classes.ratingItem}>
        <BodyRegularBold>{children}</BodyRegularBold>
      </Grid>
    );
  }

  return (
    <Grid item className={classes.ratingItem}>
      {adornment}
      {!!label && <Typography className={classes.label}>{label}</Typography>}
      <LinkButton {...props}>{children}</LinkButton>
    </Grid>
  );
};

export default RankingLinkButton;
